import React from 'react';
import { PowerBIEmbed } from 'powerbi-client-react';
import { PageContainer, Title, faBarChart } from '@/ui/components';

import { Card } from 'antd';
import { useTranslate } from '@/translations';
import { useAppCustomers } from '@/hooks';
import { ReportsContainer } from './ReportsCard.styled';

export const Reports = () => {
  const { t } = useTranslate();
  const { customerIds } = useAppCustomers();
  return (
    <PageContainer>
      <Card
        styles={{
          body: { display: 'flex', flexDirection: 'column', gap: '1rem' },
        }}
      >
        <Title title={t('reportsPowerBI')} icon={faBarChart} />
        <ReportsContainer>
          {customerIds.includes(4) ? (
            <PowerBIEmbed
              embedConfig={{
                type: 'report',
                embedUrl:
                  'https://app.powerbi.com/view?r=eyJrIjoiYTk2YTY3ODktOWJmMS00MmYwLTk5MWItMjAxNzRlNDYzMWY0IiwidCI6ImYzMDg3ZDMyLWJhYjYtNGI2Yi1iNzA3LTAyODFkZDUyOWU3NyIsImMiOjh9',
              }}
              cssClassName="report-style-class"
            />
          ) : (
            <h6>Under Development</h6>
          )}
        </ReportsContainer>
      </Card>
    </PageContainer>
  );
};
